import { PostProperties } from "../types";
import image from "../img/lostGemSandwellDistrict.jpg";

const post: PostProperties = {
  id: 12,
  title: "Sandwell District - Valhalla, Amsterdam (22.12.2012)",
  content: " ",
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/sandwell-district-valhalla-amsterdam-22-12-2012",
  category: "Lost Gem",
};

export default post;
